import React from "react";
import { PropTypes } from "prop-types";
import { HomeEmptyState, HomeListLoader, HomeOrderBySelect } from "application/home/components";
import { MrbRadioButtons } from "mrb/components/radio";
import { CategoryManageSelectedItems, CategoryGroup } from "application/categories/components";
import { MrbInfiniteScrollGrid } from "mrb/components/infinite-scroll-grid";
import { observer } from "mobx-react";

function CategoryPageMainViewTemplate({ store, t }) {
    const {
        gridStore,
        goTo,
        rootStore: { premiumSubscriptionStore },
        selectedItemsViewStore,
        orderBySelectStore,
        premiumDisabledOptions,
        selectedPremiumDisabledOption,
        changePremiumDisabledFilter,
    } = store;
    const { isBulk } = selectedItemsViewStore;

    return (
        <React.Fragment>
            <div>
                <CategoryManageSelectedItems store={selectedItemsViewStore} t={t} />
            </div>

            <div className="c-home__filter">
                <div className="c-home__filter__actions">
                    <div className="u-mar--top--sml u-mar--bottom--sml">
                        <MrbRadioButtons
                            inputClassNameExtend="c-segmented--secondary"
                            id="home-prem-dis-control"
                            name="home-prem-dis-control"
                            options={premiumDisabledOptions}
                            value={selectedPremiumDisabledOption}
                            onChange={changePremiumDisabledFilter}
                            t={t}
                        />
                    </div>
                    <div className="c-home__filter__select">
                        <HomeOrderBySelect store={orderBySelectStore} t={t} />
                    </div>
                </div>
            </div>

            <MrbInfiniteScrollGrid
                store={gridStore}
                t={t}
                classNameOverride="c-home__list--secondary"
                loadMoreLoader={<HomeListLoader row={1} />}
                loaderRenderer={() => <HomeListLoader row={3} bulk={isBulk} />}
                cellRenderer={(props) => (
                    <CategoryGroup
                        goTo={goTo}
                        premiumSubscriptionStore={premiumSubscriptionStore}
                        manageSelectedItemsViewStore={selectedItemsViewStore}
                        {...props}
                    />
                )}
                emptyStateRenderer={() => <HomeEmptyState classNameExtend="c-empty-state--no-results--lrg" t={t} />}
            />
        </React.Fragment>
    );
}

CategoryPageMainViewTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default observer(CategoryPageMainViewTemplate);
